<ion-row *ngIf="fromRegister">
  <ion-col size="12" class="ion-text-right">
    <ion-button fill="clear" color="medium" (click)="close()">
      <ion-icon name="close-outline" size="large"></ion-icon>
    </ion-button>
  </ion-col>
</ion-row>

<!-- Botón normal si NO es modal -->
<ion-row *ngIf="!fromRegister">
  <ion-col size="12" class="ion-text-left">
    <ion-button (click)="goToRegister()">
      <ion-icon color="light" size="large" slot="icon-only" name="arrow-back-outline"></ion-icon>
    </ion-button>
  </ion-col>
</ion-row>

<ion-content>
  <ion-grid fixed>
    <ion-row>
      <ion-col size="12">
        <h3 class="ion-text-center">Documentos legales</h3>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="4" class="ion-text-center">
        <ion-chip [color]="selectedDoc === 'terms' ? 'primary' : 'medium'" (click)="selectDoc('terms')">
          <ion-label><small>Términos y Condiciones</small></ion-label>
        </ion-chip>
      </ion-col>
      <ion-col size="4" class="ion-text-center">
        <ion-chip [color]="selectedDoc === 'privacy' ? 'primary' : 'medium'" (click)="selectDoc('privacy')">
          <ion-label><small>Aviso de Privacidad</small></ion-label>
        </ion-chip>
      </ion-col>
      <ion-col size="4" class="ion-text-center">
        <ion-chip [color]="selectedDoc === 'responsible' ? 'primary' : 'medium'" (click)="selectDoc('responsible')">
          <ion-label><small>Juego Responsable</small></ion-label>
        </ion-chip>
      </ion-col>
      <!-- <ion-col size="3" class="ion-text-center">
        <ion-chip [color]="selectedDoc === 'sportsRules' ? 'primary' : 'medium'" (click)="selectDoc('sportsRules')">
          <ion-label><small>Reglas Deportivas</small></ion-label>
        </ion-chip>
      </ion-col> -->
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ng-container *ngFor="let key of ['terms', 'privacy', 'responsible']">
          <ion-card *ngIf="docs[key]">
            <ion-item lines="none" color="primary" (click)="toggleDoc(key)">
              <ion-label>
                <h5>{{ docs[key]?.title }}</h5>
              </ion-label>
              <ion-icon slot="end" [name]="expanded === key ? 'remove-outline' : 'add-outline'"></ion-icon>
            </ion-item>

            <ion-card-content *ngIf="expanded === key">
              <div *ngIf="key === 'responsible' && isAuthenticated">
                <!-- <ion-button (click)="autoexclusion()" color="secondary" shape="round"> Autoexclusión </ion-button> -->
              </div>
              <div class="legal-container" [innerHTML]="docs[key]?.content"></div>
            </ion-card-content>
          </ion-card>
        </ng-container>

        <!-- <ion-card *ngIf="docs['sportsRules']">
          <ion-item color="primary" (click)="toggleDoc('sportsRules')">
            <ion-label><h5>Reglas de Apuestas Deportivas</h5></ion-label>
            <ion-icon slot="end" [name]="expanded === 'sportsRules' ? 'remove-outline' : 'add-outline'"></ion-icon>
          </ion-item>
          <ion-card-content *ngIf="expanded === 'sportsRules'">
            <iframe
              *ngIf="docs['sportsRules']?.pdfUrl"
              [src]="docs['sportsRules'].pdfUrl | safeUrl"
              width="100%"
              height="600px"
              frameborder="0"
            ></iframe>
          </ion-card-content>
        </ion-card> -->
      </ion-col>
    </ion-row>

    <ion-row class="footer-legal">
      <ion-col size="12" class="ion-text-center">
        <p class="legal-text">
          www.cmillonario.mx Operada en México por Producciones Móviles S.A. de C.V., titular del permiso
          DGAJS/SCEVF/P-06/2005-TER en unión de Unocapali la Paz Operadora S.A. de C.V. de conformidad con los oficios
          DGJS/1580/2021 y DGJS/DCRCA/2090/2022. Juegos prohibidos para menores de edad, juegue responsablemente, no
          olvide que el principal propósito es la recreación, diversión y esparcimiento.
        </p>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- Modal de Autoexclusión -->
  <ion-modal [isOpen]="showAutoModal" (didDismiss)="closeAutoModal()">
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-title>Autoexclusión</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="closeAutoModal()">
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>

      <ion-content class="ion-padding">
        <ion-item>
          <ion-label
            ><ion-text color="primary">
              <h2>
                En CMillonario nos importa tu bienestar, por eso siempre tendrás la opción de tomarte un descanso del
                juego cuando lo necesites por el tiempo que consideres adecuado, o de forma indefinida si así lo
                prefieres.
              </h2>
              <h2>
                En caso de que elijas la opción indefinida, será necesario contactar a nuestro Centro de Atención cuando
                decidas regresar. Recuerda que jugar debe ser siempre una experiencia divertida y responsable, y estamos
                aquí para apoyarte en cada paso.
              </h2>
              <h2>
                El acceso a la aplicación no se verá afectado, pero no tendrás acceso a casino, sportbook y no podrás
                realizar abonos de saldo.
              </h2>
            </ion-text></ion-label
          >
        </ion-item>
        <!-- <p>Selecciona el periodo de autoexclusión:</p> -->

        <ion-item>
          <ion-label>Periodo de exclusión</ion-label>
          <ion-select [(ngModel)]="autoexclusionPeriodo" placeholder="Selecciona uno">
            <ion-select-option value="1 ">1 mes</ion-select-option>
            <ion-select-option value="3 ">3 mes</ion-select-option>
            <ion-select-option value="6 ">6 mes</ion-select-option>
            <ion-select-option value="12 ">1 año</ion-select-option>
            <ion-select-option value="0">Indefinidamente</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Comentarios (opcional)</ion-label>
          <ion-textarea [(ngModel)]="autoexclusionComentarios"></ion-textarea>
        </ion-item>

        <ion-button expand="block" color="primary" class="ion-margin-top" (click)="guardarAutoexclusion()">
          Guardar
        </ion-button>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
